import { State, TabPanel } from "@bryntum/schedulerpro";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { getActiveEditorTab } from "../../../other/utils/otherUtils.jsx";
import MainEditorBase from "../../editors/base/MainEditorBase.jsx";

class SwivuTabPanel extends TabPanel.mixin(State) {

  static get $name() {
    return "SwivuTabPanel";
  }

  static get type() {
    return WIDGET_KEYS.swivuTabPanel;
  }

  static get configurable() {
    return {
      stateful: ["activeTab"],
      statefulEvents: ["tabChange"],
      listeners: {
        paint: "onSwivuTabPanelPaint"
      }
    };
  }

  saveState() {
    if (this.stateProvider) {
      const editorsPreviousState = this.stateProvider.getValue(PERSISTENCE_STATE_KEYS.editorTab) || {};
      this.stateProvider.setValue(PERSISTENCE_STATE_KEYS.editorTab, {
        ...editorsPreviousState,
        [this.stateId]: this.getState()
      });
    }
  }

  isValidActiveTab(tabIndex) {
    // Todo: fix needed there's a case where tab item can be hidden and currently there's no way to identify whether tab item is hidden by configuration or due to their unactive tab state
    // so this statement doesn't return proper check if tab items that have hidden property set (such as import feedback tab)
    return tabIndex < this.items.length;
  }

  // in case if the selected tab wants to dictate if it wants to be default switched on editor load
  swivuCanSwitchToTabOnLoad({ activeTab } = {}) {
    const selectedTab = this.getAt(activeTab);
    if (selectedTab.swivuCanSwitchToTabOnLoad) {
      return selectedTab.swivuCanSwitchToTabOnLoad();
    }
    return true;
  }

  load(record, context, { isFirstShow, preventTabChange }) {
    // this listener helps all tab to listen tab switching, any tab wants to listen to tab change would need to implement `onTabChangeHandler` method in tab
    this.on("tabChange", (tab) => {
      this.handleEditorUpdates();
      this.items.forEach((tabItem) => tabItem.onTabChangeHandler?.(tab))
    });
    // dealing scenarios,
    //    such as if user tab selected from user pref and user changes the tab then keep that tab
    //    or if the record is new record being created then keep default selection which is the first tab
    if (!isFirstShow || record.isPhantom || record.isDuplicateEntityHelperRecord) return;
    this.stateProvider = context.stateProvider;
    if (!preventTabChange) {
      const editorsState = this.stateProvider.getValue(PERSISTENCE_STATE_KEYS.editorTab);
      if (typeof editorsState === "object") {
        const currentTabState = editorsState[this.stateId];
        // dealing, scenario where let say tab no 6 was selected but later the tab gets missing (maybe we don't need that tab)
        if (currentTabState && this.isValidActiveTab(currentTabState.activeTab) && this.swivuCanSwitchToTabOnLoad(currentTabState)) {
          Object.assign(this, currentTabState);
        }
      }
    }
  }

  onSwivuTabPanelPaint({ firstPaint }) {
    if (firstPaint) this.handleEditorUpdates();
  }

  handleEditorUpdates() {
    const editor = this.up(MainEditorBase.type, true);
    if (editor && editor.toggleSwivuAssistButton) editor.toggleSwivuAssistButton({ activeTab: getActiveEditorTab(this) });
  }
}

SwivuTabPanel.initClass();
